/* eslint-disable jsx-a11y/anchor-is-valid */
import React from "react";
import PropTypes from "prop-types";
import createReactClass from "create-react-class";
import { ReactScriptLoaderMixin } from "react-script-loader";

const GrailpayLink = createReactClass({
    mixins: [ReactScriptLoaderMixin],

    getDefaultProps() {
        return {
            env: "sandbox",           // "sandbox" or "production"
            token: null,              // REQUIRED
            role: "business",
            timeout: 30,
            userId: null,
            vendorId: null,
            theme: null,
            buttonText: "Link Bank Account",
            className: "btn full",
            onError: () => { },
            onUserCreated: () => { },
            onBankConnected: () => { },
            onLinkedDefaultAccount: () => { },
            onExit: () => { }
        };
    },

    propTypes: {
        env: PropTypes.oneOf(["sandbox", "production"]),
        token: PropTypes.string.isRequired,
        role: PropTypes.oneOf(["business", "person"]),
        timeout: PropTypes.number,
        userId: PropTypes.string,
        vendorId: PropTypes.string,
        theme: PropTypes.object,
        buttonText: PropTypes.string,
        className: PropTypes.string,
        onError: PropTypes.func,
        onUserCreated: PropTypes.func,
        onBankConnected: PropTypes.func,
        onLinkedDefaultAccount: PropTypes.func,
        onExit: PropTypes.func
    },

    getInitialState() {
        return {
            disabledButton: true,
            sdkLoaded: false
        };
    },

    getScriptURL() {
        const SANDBOX = "https://bank-link-widget-sandbox.grailpay.com/sdk.js";
        const PROD = "https://bank-link-widget.grailpay.com/sdk.js";
        return this.props.env === "production" ? PROD : SANDBOX;
    },

    onScriptError() {
        console.error("Failed to load GrailPay SDK");
        this.props.onError({ message: "Failed to load GrailPay SDK" });
    },

    onScriptLoaded() {
        const p = this.props;

        if (!window.grailpay) {
            return p.onError({ message: "GrailPay SDK not available on window" });
        }

        // --- IDENTITY GUARD: only init once ---
        if (window.grailpay._initialized) {
            // already done, just enable the button
            this.setState({ disabledButton: false, sdkLoaded: true });
            return;
        }

        window.grailpay
            .init({
                token: p.token,
                userId: p.userId,
                vendorId: p.vendorId,
                role: p.role,
                timeout: p.timeout,
                theme: p.theme,
                onError: p.onError,
                onUserCreated: p.onUserCreated,
                onBankConnected: p.onBankConnected,
                onLinkedDefaultAccount: p.onLinkedDefaultAccount,
                onExit: p.onExit
            })
            .then(() => {
                // mark globally so future mounts skip init
                window.grailpay._initialized = true;
                this.setState({ disabledButton: false, sdkLoaded: true });
            })
            .catch(err => p.onError(err));
    },

    handleClick() {
        if (this.state.sdkLoaded && window.grailpay) {
            window.grailpay.open();
        } else {
            this.props.onError({ message: "GrailPay SDK not initialized" });
        }
    },

    render() {
        return (
            <a
                onClick={this.handleClick}
                className={this.props.className}
                style={this.state.disabledButton ? { pointerEvents: "none", opacity: 0.6 } : {}}
            >
                {this.props.buttonText}
            </a>
        );
    }
});

export default GrailpayLink;
